export default {
  initials: "Tomislav Martinčić",
  copyright: "All rights reserved"
}



// WEBPACK FOOTER //
// ./src/data/strings.js